module.exports = __webpack_public_path__ + "img/25.c581eb02.png";